import React from 'react';

// Design System Components
import Typography from 'Components/DesignSystem/Typography/Typography';

// Types
import { RegionId } from '../../../types';

// Constants
import { REGIONS } from '../../../constants';

interface RegionHeaderProps {
  region: RegionId;
  /** True while a block is being dragged anywhere in the preview. */
  isDragging: boolean;
  /** True while the drag would land in this region. */
  isActive: boolean;
}

/**
 * The name of one drop region, always rendered so the three regions are labelled
 * and the layout never shifts mid-drag (spec R48), and emphasised while a drag
 * would land here (spec R49).
 *
 * The label is the region table's own `name` — the same string the properties
 * panel shows for that region, so the two wordings cannot drift.
 */
const RegionHeader = ({ region, isDragging, isActive }: RegionHeaderProps) => {
  const definition = REGIONS.find((candidate) => candidate.id === region);
  if (!definition) {
    return null;
  }

  const tone = isActive
    ? 'tw-text-accent tw-font-semibold'
    : isDragging
      ? 'tw-text-ink-secondary'
      // grey-600 (4.52:1). Region headers are text a user reads to know which
      // drop zone they are in; grey-500 is 2.64:1 and is non-text only.
      : 'tw-text-ink-tertiary';

  return (
    <div className="tw-flex tw-items-center tw-gap-1 tw-h-4">
      <Typography variant="caption-metadata" as="span" className={tone}>
        {definition.name}
      </Typography>
    </div>
  );
};

export default RegionHeader;
